export { default as DynamicPopularPosts } from './DynamicPopularPosts';
